import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import VbRechercheDetailsComponent from "../components/VbRechercheDetailsComponent.vue";
import RechercheMessage from "@/shared/model/RechercheMessage";
import apiVbRecherche from "@/modules/VbRecherche/api";

import {ref, watch} from "vue";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import getGuid from "@/shared/utils/getGuid";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";

interface Props {
  evb?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VbRechercheDetailsPage',
  props: {
    evb: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const loading = ref(true);

const _evb = ref("");
const _key = ref("");

watch(
  props,
  () => {
    _evb.value = props.evb ?? "";
  },
  {immediate: true}
);

watch(
  _evb,
  () => {
    _key.value = getGuid();
    loadMessage(_key.value);
  },
  {immediate: true}
);

async function loadMessage(key: string) {
  const res = await apiVbRecherche.load(_evb.value);

  if (key === _key.value) {
    if (res) {
      rechercheMessage.value = res;
    }
    loading.value = false;
  }
}

const rechercheMessage = ref<RechercheMessage>({
  versicherungsbestaetigungsnummer: "",
  vbStatusString: "unbekant",
} as RechercheMessage);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: "VB-Recherche"
  }, {
    top: _withCtx(() => [
      _createVNode(SogCardActions, { "is-toolbar": true }, {
        default: _withCtx(() => [
          _createVNode(SogCardActionButton, {
            kind: _unref(SogButtonKind).Back
          }, null, 8, ["kind"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
        [_vShow, loading.value]
      ]),
      (!loading.value)
        ? (_openBlock(), _createBlock(VbRechercheDetailsComponent, {
            key: 0,
            "recherche-message": rechercheMessage.value
          }, null, 8, ["recherche-message"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})